import { HotelCardInfoOptionsPropertiesType } from "@website/accommodation-ui/hotel-card-new/hotel-card-info/hotel-card-info-options/hotel-card-info-options.types";
import { useViewPort } from "@website/hooks/viewport";
import { MaterialIcon } from "@website/icons/material";
import { MiniChips } from "@website/ui/mini-chips";
import { deepCompare } from "@website/utils/deep-compare";
import upperFirst from "lodash-es/upperFirst";
import { FC, memo } from "react";

const Component: FC<HotelCardInfoOptionsPropertiesType> = (properties) => {
  const { regularBadges, size = "responsive", facilities } = properties;
  const { isMobile } = useViewPort();

  if (isMobile && !regularBadges?.length) return null;

  return (
    <div className={properties.className}>
      <div className="flex flex-col gap-3">
        {(facilities?.length ?? 0) > 0 &&
          size !== "small" &&
          size !== "xSmall" && (
            <div className="scrollbar-none !hidden flex-wrap items-center gap-1 overflow-x-auto sm:!flex">
              {facilities?.map(({ icon, id, title }) => (
                <MiniChips
                  StartIcon={
                    icon ? (
                      <MaterialIcon name={icon} variant="outlined" />
                    ) : undefined
                  }
                  className="!text-on-surface-medium-emphasis !bg-white"
                  key={id}
                  text={upperFirst(title) ?? ""}
                />
              ))}
            </div>
          )}
        {size !== "small" && size !== "xSmall" && (
          <div className="scrollbar-none flex flex-wrap items-center gap-2 overflow-x-auto">
            {regularBadges?.map(({ text, color, icon, textStyle, tooltip }) => (
              <MiniChips
                StartIcon={
                  icon ? (
                    <MaterialIcon
                      className={textStyle}
                      name={icon}
                      variant="outlined"
                    />
                  ) : undefined
                }
                className="!h-[24px] !px-2 !py-1"
                color={color}
                key={text}
                size="medium"
                text={text ?? ""}
                textClassName={`text-caption ${
                  color === "#EBECF2" ? "text-on-surface-high-emphasis" : ""
                }`}
                tooltip={tooltip}
                // transparent={transparent}
                variant="contained"
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export const HotelCardInfoOptions = memo(Component, deepCompare);
